import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { DEFAULT_SHORT_DATE_CONFIG, displayTemporal } from 'utils';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project/BinderDeliveriesPage/constants';
import * as constants from './constants';
import { EditBinderDeliveryPageParams } from './constants';
import useEditBinderDeliveryQueries, { EditBinderDeliveryQueries } from './useEditBinderDeliveryQueries';

const EditBinderDeliveryPage = lazyWithSuspense(() => import('./EditBinderDeliveryPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage<EditBinderDeliveryPageParams, EditBinderDeliveryQueries>({
    WrappedPage: EditBinderDeliveryPage,
    titleFn: ([binderDelivery]) => (binderDelivery.data ? i18n._(displayTemporal(binderDelivery.data.deliveryDate, DEFAULT_SHORT_DATE_CONFIG)) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditBinderDeliveryQueries,
  }),
};

export default page;
